import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import actions from "../../redux/actions/RestActions";
import authActions from "../../redux/actions/AuthActions";
import layoutActions from "../../redux/actions/LayoutActions";
import { getSVG } from "../../utils/getSvg"
import { GetScreenSize } from "../../utils/screenSize";
import { LoadingButton } from '@cloudix-ai/components'
import { useHistory } from "react-router-dom";
import Logo from '../../assets/images/new-logo.png'
import LogoNoName from '../../assets/images/logo-noname.png'
import {
  Box,
  Toolbar,
  Button,
  MenuItem,
  useTheme,
  styled,
  InputBase,
  Autocomplete,
  TextField,
  Divider,
  useMediaQuery
} from "@mui/material";
import NavBarRoot, { SHELL_SIDENAV_DOCKED } from './NavBarRoot'
import StyledMenu from './StyledMenu'
import HeaderSearch from './HeaderSearch'
import HeaderBell from './HeaderBell'
import HeaderOverflowActions from './HeaderOverflowActions'
import ContextBar, { useContextBarSpace, useInsideModal } from './ContextBar'
import { getTranslation, getField, getFieldData, getPagePermissionByPath } from "../../utils/utils";
import { getPagePermission } from "../../utils/utils";
import Notifications from "./Notifications";
import notificationsActions from '../../redux/actions/NotificationsActions'
import { isEmbedded } from '../../utils/embed'
import { useHeaderRefresh } from '../../contexts/HeaderRefreshContext'
import RestaurantBranchSelector from '../RestaurantBranchSelector'

const Header = ({
  sideNavState,
  sideNavChange,
  logout,
  onSave,
  onCancel,
  isSubmitting,
  leftComponents,
  updateHeaderState,
  translation,
  language,
  extraComponent,
  admin,
  disabled,
  disableBurgerMenu,
  belowHeader,
  setSelectedRest,
  restaurants,
  selectedRestaurant,
  isEntitySelection,
  permissions,
  viewNotifications,
  forceEnableRestaurantSelect,
  replaceLeft,
  extraComponentsLeft,
  hasEntitiesSwitch = false,
  disableLogo,
  logoAlignment,
  isDashboard = false,
  notificationOpen,
  setNotificationOpen,
  notifications,
  supportedLanguages,
  hoverNavState,
  hoverNavChange,
  enableDivider = false,
  cancelText = null,
  allNavChange
}) => {
  const accessUsers = getPagePermission(permissions, 'users')
  const [isGlobal, setIsGlobal] = useState(false)

  useEffect(() => {
    let page = getPagePermissionByPath(permissions, window.location.pathname)
    setIsGlobal(page?.isGlobal)
  }, [window.location.pathname, permissions])

  //SELECT COMPONENT
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
      fontSize: 12, // Change the font size as needed
      fontWeight: 'bold',
      color: 'red', // Change the text color as needed
      textAlign: 'center', // Align the text to the center
      //borderBottom: 'none', // Remove the bottom line
      padding: '1px', // Add padding as needed
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      textAlign: 'center', // Align placeholder text to the center
    },
    '& .MuiInputBase-input:-moz-placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input::-moz-placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input:-ms-input-placeholder': {
      textAlign: 'center',
    },
  }));

  const [chooseLangModalState, setChooseLangModalState] = useState(false)
  const closeChooseLanguage = () => {
    setChooseLangModalState(false)
  }
  const dictionary = getTranslation('header', translation)
  const theme = useTheme()

  // When this header renders inside the SMA print-settings popup (same-origin
  // iframe) the burger/sidebar toggle is hidden and the header's built-in Cancel
  // button doubles as the popup close: it asks the parent window to close.
  const embedded = isEmbedded()
  const closeEmbedPopup = () => {
    try {
      if (window.parent) {
        window.parent.postMessage({ type: 'SMA_PRINT_SETTINGS_CLOSE' }, window.location.origin)
      }
    } catch (e) {
      /* ignore cross-origin */
    }
  }
  // Reuse the built-in Cancel button as the popup close when embedded, unless the
  // page already supplies its own onCancel handler.
  const effectiveOnCancel = onCancel || (embedded ? closeEmbedPopup : undefined)

  // Present only when a host screen offers a refresh (see HeaderRefreshContext).
  const headerRefresh = useHeaderRefresh()
  // getField returns the literal "No translation" for missing keys, so `||` can't be used here.
  const refreshTranslated = getField(dictionary, "refresh", language)
  const refreshLabel =
    refreshTranslated && refreshTranslated !== "No translation" ? refreshTranslated : "Refresh"

  useEffect(() => {
    if (onSave || onCancel) {
      updateHeaderState(true)
    }
  }, [onSave, onCancel])


  const screenSize = GetScreenSize()
  const [userMenu, setUserMenu] = useState(false);
  const open = Boolean(userMenu);
  const history = useHistory()
  const handleClick = (event) => {
    setUserMenu(event.currentTarget);
  };


  const handleActions = (act) => {
    setUserMenu(false)
    if (act)
      switch (act) {
        case 'logout':
          logout()
          break
        case 'account-settings':
          history.push('/user-profile')
          break
        case 'choose-lang':
          setChooseLangModalState(true)
          break
        case 'users':
          history.push('/users')
          break
        default:
          return ('')
      }
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const loadingButtonDictionary = getTranslation('loading-button', translation)

  const handleClickNotification = (event) => {
    setAnchorEl(event.currentTarget);

  };

  const notificationsRef = React.useRef(null)
  useEffect(() => {
    if (notificationOpen) {
      // Create a fake event object with the required currentTarget property
      const mockEvent = {
        currentTarget: notificationsRef.current
      };

      // Now pass this mock event to the handler
      handleClickNotification(mockEvent);
    }
  }, [notificationOpen]);

  const handleClose = () => {
    viewNotifications();
    setAnchorEl(null);
    setNotificationOpen(false)
  };

  const [currentRestaurant, setCurrentRestaurant] = useState(null);

  useEffect(() => {
    if (!selectedRestaurant) return;

    const foundRestaurant = restaurants.find(
      (restaurant) => restaurant.uuid === selectedRestaurant
    );

    setCurrentRestaurant(foundRestaurant || null);
  }, [selectedRestaurant, restaurants]);

  const openNotification = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;

  const memoizedUserMenu = useMemo(() => {
    return (
      <StyledMenu
        anchorEl={userMenu}
        open={open}
        onClose={() => setUserMenu(false)}
      >
        <MenuItem onClick={() => handleActions("account-settings")}>
          {getField(dictionary, "account-settings", language)}
        </MenuItem>
        {accessUsers && (
          <MenuItem onClick={() => handleActions("users")}>
            {getField(dictionary, "users", language)}
          </MenuItem>
        )}
        <MenuItem onClick={() => handleActions("logout")}>
          {getField(dictionary, "logout", language)}
        </MenuItem>
        <MenuItem onClick={() => handleActions("choose-lang")}>
          {getField(dictionary, "language-settings", language)}
        </MenuItem>
      </StyledMenu>
    );
  }, [userMenu, open, dictionary, language, accessUsers]);

  // A phone's header row has no room for the restaurant / branch names: they get a bar of their own
  // under it (ContextBar), and the admin shell's spacer under the header grows by it. Not in a
  // dialog: an editor there clears just the 50px row, so it keeps the names in the row.
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  const [headerRowRef, insideModal] = useInsideModal()
  // A page with its own restaurant / branch control hands it over as `replaceLeft`; it goes to the
  // bar too. Anything else there (a title, a product name) stays in the row.
  const replaceLeftIsContextControl = React.isValidElement(replaceLeft) && replaceLeft.type === RestaurantBranchSelector
  const contextInBar = isPhone && !insideModal
    && (replaceLeft ? replaceLeftIsContextControl : (!isGlobal || forceEnableRestaurantSelect))
  useContextBarSpace(contextInBar)
  const contextBar = contextInBar && (
    <ContextBar>
      {replaceLeft ? React.cloneElement(replaceLeft, { bar: true }) : (
        <RestaurantBranchSelector hideBranchSelect={!extraComponentsLeft} bar />
      )}
      {!replaceLeft && extraComponentsLeft && <Box sx={{ flexShrink: 0 }}>{extraComponentsLeft}</Box>}
    </ContextBar>
  )

  // Below 700px Save / Cancel shrink to icons; the page's own labelled buttons go behind one
  // "more" button, so they don't wrap in the row and squeeze the logo.
  const pageActions = extraComponent && (screenSize.dynamicWidth < 700 ? (
    <HeaderOverflowActions label={getField(dictionary, 'more-actions', language)}>
      {extraComponent}
    </HeaderOverflowActions>
  ) : extraComponent)

  const handleMouseOver = () => {
    hoverNavChange(true);
  };

  if (!isDashboard)
    return (
      <NavBarRoot contextBar={contextInBar}>
        <Toolbar ref={headerRowRef} variant="dense" sx={{
          display: "flex",
          alignItems: "center",
          maxWidth: "100%",
          // Tighter gutters on a phone: the room goes to the restaurant / branch names.
          px: { xs: 1, sm: 3 },
        }}>
          {!disableBurgerMenu && !embedded && (
            <Box
              onMouseEnter={handleMouseOver}
              sx={{
                backgroundColor: sideNavState
                  ? theme.palette.menuButton.activeBackgroundColor
                  : theme.palette.menuButton.backgroundColor,
                padding: "5px",
                display: "flex",
                alignItems: "center",
                borderRadius: "8px",
                cursor: "pointer",
                zIndex: 10,
                // The shell's docked sidebar opens and closes itself with its logo.
                [SHELL_SIDENAV_DOCKED]: { display: "none" },
                "&:active": {
                  backgroundColor: "rgba(0,0,0,0.4)"
                }
              }}
              onClick={() => {
                sideNavChange();
              }}
            >
              {getSVG("menu-open", theme.palette.topNavSvg, { width: 25, height: 25 }, sideNavState, {
                headerArrow: true,
                translateY: sideNavState ? "0px" : "3px"
              })}
            </Box>
          )}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            ml: 2,
            // The shell's docked sidebar shows the logo.
            [SHELL_SIDENAV_DOCKED]: { display: 'none' },
          }}>
            {/* The full logo on a phone too once the restaurant / branch names have moved to the bar. */}
            <img src={screenSize.dynamicWidth > 700 || contextInBar ? Logo : LogoNoName} alt="Logo" style={{ height: 25, width: 'auto' }} />
          </Box>
          <Box
            sx={{
              height: '100%',
              width: '1px',
              zIndex: 999999999999999999999,
            }}
            onMouseLeave={() => allNavChange(false)}
          />
          {/* {!isGlobal && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: 2,
              }}
            >
              {(!disableLogo && currentRestaurant && currentRestaurant.logo !== '') && (
                <Box
                  key={`logo-${currentRestaurant.uuid}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    height: 35,
                    padding: '5px',
                    overflow: "visible",
                    whiteSpace: "nowrap"
                  }}
                >
                  <img
                    src={currentRestaurant.logo}
                    alt={getFieldData(currentRestaurant, "name", language)}
                    style={{
                      height: 35,
                      borderRadius: "5px",
                      border: `1px solid ${theme.palette.primary.main}`,
                    }}
                  />
                </Box>
              )}
            </Box>
          )} */}
          {!replaceLeft ? (
            (!isGlobal || forceEnableRestaurantSelect) && !contextInBar && (
              <Box sx={{
                gap: 1,
                display: 'flex',
                alignItems: 'center',
                marginLeft: 2,
                // Shrinks on a phone, so the restaurant / branch names are cut rather than pushing the buttons off.
                flex: '0 1 auto',
                minWidth: 0,
              }}>
                <RestaurantBranchSelector hideBranchSelect={!extraComponentsLeft} />
                {extraComponentsLeft &&
                  <Box>
                    {extraComponentsLeft}
                  </Box>
                }
              </Box>
            )
          ) : !contextInBar && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: 2,
                flexShrink: 0,
              }}
            >
              {replaceLeft}
            </Box>
          )}

          {/* Previous: ...(sideNavState && screenSize.dynamicWidth > 700 && { marginLeft: "200px" }) — removed to keep top nav static when sidebar opens */}
          {!embedded && <HeaderSearch placeholder={getField(dictionary, 'global-search-placeholder', language)} />}
          {/* Sized to its buttons: the search takes the room between them and the context control. */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", flex: "0 1 auto", minWidth: 0, marginLeft: "auto" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              {/* Reloads whatever the host's active tab shows. Same control as the Dashboard
                  header: 37x37 rounded box, tinted active while the reload is in flight. */}
              {headerRefresh?.onRefresh && (
                <Box
                  role="button"
                  tabIndex={0}
                  aria-label={refreshLabel}
                  title={refreshLabel}
                  onClick={() => {
                    if (!headerRefresh.refreshing) headerRefresh.onRefresh()
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    alignSelf: "center",
                    marginRight: 0.5,
                    backgroundColor: headerRefresh.refreshing
                      ? theme.palette.menuButton.activeBackgroundColor
                      : theme.palette.menuButton.backgroundColor,
                    padding: 1,
                    borderRadius: "8px",
                    width: 37,
                    height: 37,
                    flexShrink: 0,
                    cursor: headerRefresh.refreshing ? "default" : "pointer",
                    opacity: headerRefresh.refreshing ? 0.6 : 1,
                  }}
                >
                  {getSVG("refresh", theme.palette.primary.main, { width: 20, height: 20 })}
                </Box>
              )}
              {leftComponents}
              {pageActions}

              {effectiveOnCancel && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={effectiveOnCancel}
                  sx={{
                    ...screenSize.dynamicWidth < 700 && {
                      padding: '2px 6px',
                      minHeight: '30px',
                      minWidth: '30px',
                      lineHeight: 1,
                    }
                  }}
                >
                  {screenSize.dynamicWidth > 700
                    ? (cancelText? cancelText : getField(dictionary, "cancel", language))
                    : getSVG('cancel', theme.palette.white, { width: 15, height: 15 })}
                </Button>

              )}

              {onSave && (
                <LoadingButton
                  dictionary={loadingButtonDictionary}
                  language={language}
                  disabled={isSubmitting || disabled}
                  isSubmitting={isSubmitting}
                  title={screenSize.dynamicWidth > 700 ? getField(dictionary, "save", language) : getSVG('save', theme.palette.white, { width: 15, height: 15 })}
                  variant="contained"
                  sx={{
                    marginLeft: 0.5,
                    ...screenSize.dynamicWidth < 700 && {
                      padding: '2px 6px',
                      minHeight: '30px',
                      minWidth: '30px',
                      lineHeight: 1,
                    }
                  }}
                  onClick={onSave}
                  size="small"
                />
              )}
            </Box>
            <HeaderBell
              ref={notificationsRef}
              unread={notifications.filter((not) => !not.seenAt).length}
              label={getField(dictionary, 'notifications-label', language)}
              onClick={handleClickNotification}
              describedBy={id}
            />
            {/* <Button
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleClick}
              sx={{ marginLeft: 0.5, minWidth: screenSize.dynamicWidth > 667 ? 100 : 40, padding: "6px", width: "auto" }}
              endIcon={
                screenSize.dynamicWidth > 667
                  ? getSVG("arrow-down", theme.palette.userMenu.icons, { width: 10, height: 10 }, userMenu)
                  : null
              }
              size="small"
            >
              {getSVG("Person", theme.palette.userMenu.icons, { width: 20, height: 20 }, null, {
                marginRight: screenSize.dynamicWidth > 666 ? 7 : 0,
              })}
              {screenSize.dynamicWidth > 667
                ? admin
                  ? admin.firstName
                  : getField(dictionary, "user", language)
                : null}
            </Button>

            {memoizedUserMenu} */}

            <Notifications
              open={openNotification}
              id={id}
              anchorEl={anchorEl}
              handleClose={handleClose}
              dictionary={dictionary}
              language={language}
            />
          </Box>
        </Toolbar>
        {contextBar}
        {enableDivider &&
          <Divider
            sx={{
              borderColor: (theme) =>
                theme.palette.grey[300],
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
            }}
          />
        }
        {belowHeader && (
          <Toolbar sx={{ minHeight: "50px !important", display: "flex", alignItems: "center", maxWidth: "100%", paddingBottom: "5px" }}>
            {belowHeader}
          </Toolbar>
        )}
      </NavBarRoot>
    );
  else {
    return (
      <NavBarRoot contextBar={contextInBar}>
        <Toolbar ref={headerRowRef} variant="dense" sx={{
          display: "flex",
          alignItems: "center",
          maxWidth: "100%",
          // Tighter gutters on a phone: the room goes to the restaurant / branch names.
          px: { xs: 1, sm: 3 },
        }}>
          {!disableBurgerMenu && !embedded && (
            <Box
              onMouseEnter={handleMouseOver}
              sx={{
                backgroundColor: sideNavState
                  ? theme.palette.menuButton.activeBackgroundColor
                  : theme.palette.menuButton.backgroundColor,
                padding: "6px",
                display: "flex",
                alignItems: "center",
                borderRadius: "8px",
                cursor: "pointer",
                zIndex: 10,
                // The shell's docked sidebar opens and closes itself with its logo.
                [SHELL_SIDENAV_DOCKED]: { display: "none" },
                "&:active": {
                  backgroundColor: "rgba(0,0,0,0.4)"
                }
              }}
              onClick={() => {
                sideNavChange();
              }}
            >
              {getSVG("menu-open", theme.palette.topNavSvg, { width: 25, height: 25 }, !sideNavState, {
                headerArrow: true,
                translateY: sideNavState ? "0px" : "3px"
              })}
            </Box>
          )}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            ml: 2,
            [SHELL_SIDENAV_DOCKED]: { display: 'none' },
          }}>
            {/* The full logo on a phone too once the restaurant / branch names have moved to the bar. */}
            <img src={screenSize.dynamicWidth > 700 || contextInBar ? Logo : LogoNoName} alt="Logo" style={{ height: 25, width: 'auto' }} />
          </Box>
          <Box
            sx={{
              height: '100%',
              width: '1px',
              zIndex: 999999999999999999999,
            }}
            onMouseLeave={() => allNavChange(false)}
          />
          {/* {!isGlobal && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: 2,
              }}
            >
              {(!disableLogo && currentRestaurant && currentRestaurant.logo !== '') && (
                <Box
                  key={`logo-${currentRestaurant.uuid}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    height: 35,
                    padding: '5px',
                    overflow: "visible",
                    whiteSpace: "nowrap"
                  }}
                >
                  <img
                    src={currentRestaurant.logo}
                    alt={getFieldData(currentRestaurant, "name", language)}
                    style={{
                      height: 35,
                      borderRadius: "5px",
                      border: `1px solid ${theme.palette.primary.main}`,
                    }}
                  />
                </Box>
              )}
            </Box>
          )} */}
          {!replaceLeft ? (
            (!isGlobal || forceEnableRestaurantSelect) && !contextInBar && (
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: 2,
                // Shrinks on a phone, so the restaurant / branch names are cut rather than pushing the buttons off.
                flex: '0 1 auto',
                minWidth: 0,
              }}>
                <RestaurantBranchSelector hideBranchSelect={!extraComponentsLeft} />
                {extraComponentsLeft &&
                  <Box>
                    {extraComponentsLeft}
                  </Box>
                }
              </Box>
            )
          ) : !contextInBar && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: 2,
                flexShrink: 0,
              }}
            >
              {replaceLeft}
            </Box>
          )}

          {!embedded && <HeaderSearch placeholder={getField(dictionary, 'global-search-placeholder', language)} />}
          {/* Sized to its buttons: the search takes the room between them and the context control. */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", flex: "0 1 auto", minWidth: 0, marginLeft: "auto" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              {leftComponents}
              {pageActions}

              {effectiveOnCancel && (
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ marginRight: 0.5 }}
                  onClick={effectiveOnCancel}
                  size="small"
                >
                  {getField(dictionary, "cancel", language)}
                </Button>
              )}

              {onSave && (
                <LoadingButton
                  dictionary={loadingButtonDictionary}
                  language={language}
                  disabled={isSubmitting || disabled}
                  isSubmitting={isSubmitting}
                  title={getField(dictionary, "save", language)}
                  variant="contained"
                  sx={{ marginLeft: 0.5 }}
                  onClick={onSave}
                  size="small"
                />
              )}
            </Box>
            <HeaderBell
              ref={notificationsRef}
              unread={notifications.filter((not) => !not.seenAt).length}
              label={getField(dictionary, 'notifications-label', language)}
              onClick={handleClickNotification}
              describedBy={id}
            />
            {/* <Button
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleClick}
              sx={{ marginLeft: 0.5, minWidth: screenSize.dynamicWidth > 1250 ? 100 : 40, padding: "6px", width: "auto" }}
              size="small"
              endIcon={
                screenSize.dynamicWidth > 1250
                  ? getSVG("arrow-down", theme.palette.userMenu.icons, { width: 10, height: 10 }, userMenu)
                  : null
              }
            >
              {getSVG("Person", theme.palette.userMenu.icons, { width: 20, height: 20 }, null, {
                marginRight: screenSize.dynamicWidth > 1250 ? 7 : 0,
              })}
              {screenSize.dynamicWidth > 1250
                ? admin
                  ? admin.firstName
                  : getField(dictionary, "user", language)
                : null}
            </Button> */}

            {/* {memoizedUserMenu} */}

            <Notifications
              open={openNotification}
              id={id}
              anchorEl={anchorEl}
              handleClose={handleClose}
              dictionary={dictionary}
              language={language}
            />
          </Box>
        </Toolbar>
        {contextBar}
        {belowHeader && (
          <Toolbar sx={{ minHeight: "50px !important", display: "flex", alignItems: "center", maxWidth: "100%", paddingBottom: "5px" }}>
            {belowHeader}
          </Toolbar>
        )}

      </NavBarRoot>
    );
  }
};

const mapStateToProps = (state) => ({
  translation: state.translation.translation,
  language: state.translation.language,
  sideNavState: state.layout.settings?.layoutSettings?.sidebar?.open || state.layout.settings?.layoutSettings?.sidebar?.hover,
  admin: state.auth.admin,
  selectedRestaurant: state.rest.selectedRest,
  restaurants: state.rest.restaurants,
  selectedEntity: state.entities.selectedEntity,
  isEntitySelection: state.entities.isEntitySelection,
  permissions: state.auth.permissions,
  notificationOpen: state.layout.notificationOpen,
  notifications: state.notifications.notifications,
  supportedLanguages: state.translation.supportedLanguages,
});
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(authActions.logout()),
  setSelectedRest: (value) => dispatch(actions.setSelectedRest(value)),
  sideNavChange: (state) => dispatch(layoutActions.allNavChange(state)),
  updateHeaderState: (state) => dispatch(layoutActions.updateHeaderState(state)),
  viewNotifications: () => dispatch(notificationsActions.viewNotifications()),
  setNotificationOpen: (state) => dispatch(layoutActions.setNotificationOpen(state)),
  hoverNavChange: (state) => dispatch(layoutActions.hoverNavChange(state)),
  allNavChange: (state) => dispatch(layoutActions.allNavChange(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);